// import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
// import * as translateAPI from "./TranslateApi";

// export const translateTextAsync = createAsyncThunk(
//   "translate/translateText",
//   async ({ text, source, target, field }) => {
//     const translatedText = await translateAPI.translateText(
//       text,
//       source,
//       target
//     );
//     return { text: translatedText, field };
//   }
// );

// const initialState = {
//   status: "idle",
//   error: null,
//   translatedText: {},
// };

// export const translateSlice = createSlice({
//   name: "translate",
//   initialState,
//   reducers: {
//     clearTranslation: (state) => {
//       state.translatedText = {};
//       state.status = "idle";
//       state.error = null;
//     },
//   },
//   extraReducers: (builder) => {
//     builder
//       .addCase(translateTextAsync.pending, (state) => {
//         state.status = "loading";
//       })
//       .addCase(translateTextAsync.fulfilled, (state, action) => {
//         state.status = "succeeded";
//         state.translatedText[action.payload.field] = action.payload.text;
//       })
//       .addCase(translateTextAsync.rejected, (state, action) => {
//         state.status = "failed";
//         state.error = action.error.message;
//       });
//   },
// });

// export const { clearTranslation } = translateSlice.actions;

// export const selectTranslatedText = (state) => state.translate.translatedText;

// export default translateSlice.reducer;

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

const apiKey = "AIzaSyDwjESwmP6-PBFgiJcKS0HZQqg9NVqjqAA";

const translateText = async (text, source, target) => {
  try {
    const response = await axios.post(
      `https://www.googleapis.com/language/translate/v2?key=${apiKey}`,
      {
        q: text,
        source: source,
        target: target,
        format: "text",
      }
    );
    return response.data.data.translations[0].translatedText;
  } catch (error) {
    throw new Error("Translation failed.");
  }
};

export const translateTextAsync = createAsyncThunk(
  "translate/translateText",
  async ({ text, source, target, field }) => {
    const translatedText = await translateText(text, source, target);
    return { text: translatedText, field };
  }
);

const initialState = {
  status: "idle",
  error: null,
  translatedText: {
    Name: "", // Initialize for Name field
    Relative: "", // Initialize for Relative field
  },
};

export const translateSlice = createSlice({
  name: "translate",
  initialState,
  reducers: {
    clearTranslation: (state) => {
      state.translatedText = {
        Name: "",
        Relative: "",
      };
      state.status = "idle";
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(translateTextAsync.pending, (state) => {
        state.status = "loading";
      })
      .addCase(translateTextAsync.fulfilled, (state, action) => {
        state.status = "succeeded";
        const { field, text } = action.payload;
        state.translatedText[field] = text; // Store translated text under the respective field key
      })
      .addCase(translateTextAsync.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

export const { clearTranslation } = translateSlice.actions;

export const selectTranslatedText = (state) => state.translate.translatedText;

export default translateSlice.reducer;
